import { forEach } from "lodash";
import { newPlannerMacroAllocationCell } from "../newCell";
import { isPlanningAccessReadonlyForRootGroup } from "src/allocation/util/planningAccess";

import {
  PLANNER_CURRENT,
  PLANNER_REQUESTED,
  PLANNER_APPROVED,
} from "../../../columnTypes";

const setLineItemWithPlannerCells = ({
  lineItem,
  macroAllocations,
  isRequestor,
  allocationProjectLookup,
  approvalReasons,
  useDeltaForBudget,
  isRealtimeFteMode,
  useRealtimeChangeOnly,
  useRealtimeFteDelta,
  enableDemandRequest = false,
  rootGroup,
}) => {
  const isPlanningAccessReadonly =
    isPlanningAccessReadonlyForRootGroup(rootGroup);

  forEach(macroAllocations, (macroAllocation) => {
    const allocationProject =
      allocationProjectLookup[macroAllocation.allocationProjectId];
    const currentCell = newPlannerMacroAllocationCell({
      lineItem,
      macroAllocation,
      columnType: PLANNER_CURRENT,
      isRequestor,
      isEditable: false,
    });
    const requestorCell = newPlannerMacroAllocationCell({
      lineItem,
      macroAllocation,
      allocationProject,
      columnType: PLANNER_REQUESTED,
      isRequestor,
      isEditable:
        isRequestor &&
        !allocationProject.isRequestorPlannerReadonly &&
        !isPlanningAccessReadonly,
      useDeltaForBudget,
      isRealtimeFteMode,
      useRealtimeChangeOnly,
      useRealtimeFteDelta,
      enableDemandRequest,
    });
    const approverCell = newPlannerMacroAllocationCell({
      lineItem,
      macroAllocation,
      columnType: PLANNER_APPROVED,
      isApprover: !isRequestor,
      isEditable:
        !isRequestor &&
        !allocationProject.isApproverPlannerReadonly &&
        !isPlanningAccessReadonly,
      approvalReasons,
    });

    lineItem.cells = [currentCell, requestorCell, approverCell];
  });
};

export default setLineItemWithPlannerCells;
